import { useQuery } from "@tanstack/react-query";
import useAuth from "hooks/useAuth";
import { fetchTableNames } from "../Services/fetchTableNames";

export default function useTableNames() {
  const { accessToken } = useAuth();

  return useQuery({
    queryKey: ["serviceOperation", "tableNames"],
    queryFn: () => fetchTableNames({ accessToken }),
    staleTime: Infinity,
    enabled: !!accessToken,
    retry: false,
  });
}